export default __webpack_public_path__ + "static/media/GrayMarker.eb406037.svg";